import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoadMore = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 15.6666C11.2856 15.6666 12.5423 15.2854 13.6112 14.5712C14.6801 13.857 15.5132 12.8418 16.0052 11.6541C16.4972 10.4664 16.6259 9.15942 16.3751 7.89854C16.1243 6.63766 15.5052 5.47948 14.5962 4.57043C13.6872 3.66139 12.529 3.04233 11.2681 2.79152C10.0072 2.54072 8.70028 2.66944 7.51256 3.16141C6.32484 3.65338 5.30968 4.4865 4.59545 5.55542C3.88122 6.62434 3.5 7.88105 3.5 9.16663V9.66663",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 7.66467L3.5 9.66467L5.5 7.66467",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 5.16467V9.66467H13",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgLoadMore);
export default ForwardRef;
